import { Text } from "@overmap-ai/blocks"
import { type IssueUpdate, type Stored, UNTITLED_ISSUE_TITLE } from "@overmap-ai/common"
import { selectIssueById, selectUserById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { interactiveTextCva } from "../../cva"
import { ProjectTimelineItemType } from "../../enums/projects"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { IssueTypeIcon } from "../Icons/IssueTypeIcon"
import { IssueIndexLabel } from "../IndexLabels/IssueIndex"
import { ProjectTimelineCard } from "./ProjectTimelineCard"
import { getTimelineDate } from "./utils"

interface ProjectTimelineIssueUpdateItemProps {
	issueUpdate: Stored<IssueUpdate>
}

export const ProjectTimelineIssueUpdateItem = memo<ProjectTimelineIssueUpdateItemProps>((props) => {
	const { issueUpdate } = props

	const user = useAppSelector(selectUserById(issueUpdate.created_by ?? -1))
	const issue = useAppSelector(selectIssueById(issueUpdate.issue))!

	return (
		<ProjectTimelineCard type={ProjectTimelineItemType.ISSUE_UPDATE}>
			<Text size="sm" accentColor="base" className="min-w-0">
				<Text highContrast>{getUserDisplayLabel(user)}</Text>
				&nbsp;updated issue&nbsp;
				<Link
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/issues/$issueId"
					params={{ issueId: issue.uuid }}
				>
					<Text highContrast className={interactiveTextCva()}>
						<IssueTypeIcon className="align-sub" issueTypeId={issue.issue_type} />
						&nbsp;
						<IssueIndexLabel issueId={issue.uuid} highContrast />
						<Text accentColor="base">&nbsp;{issue.title || UNTITLED_ISSUE_TITLE}</Text>
					</Text>
				</Link>
				<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(getTimelineDate(issueUpdate))}</Text>
			</Text>
		</ProjectTimelineCard>
	)
})
ProjectTimelineIssueUpdateItem.displayName = "ProjectTimelineIssueUpdateItem"
